import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import MessageGrid from '../../purchaseRequisition/messageGrid';
import ApiService from '../../../services/apiService';
import ItemGridGRN from './itemGrid';
import { toast } from 'react-toastify';
import AuthorizationGrn from '../authorization';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../../Redux/selecters';
import { RiRefreshLine } from 'react-icons/ri';
import { FaSave } from 'react-icons/fa';
import { FaAngleLeft } from 'react-icons/fa6';
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import Attachment from '../../Attachment/attachment';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';

const createEmptyRow = () => ({
  id: Date.now() + Math.random(),
  file: null,
  fileName: "",
  remarks: "",
});

const CreateGrn = () => {
  const [activeTab, setActiveTab] = useState(0);
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
  const [gridVisibility, setGridVisibility] = useState([true, false, false]);
  const apiService = new ApiService();
  const [messageData, setMessageData] = useState([]);
  const [authorizationData, setAuthorizationData] = useState([]);
  const [ItemData, setItemData] = useState([]);
  const [PurchaseOrderDate, setPurchaseOrderDate] = useState();
  const { currencyPrecision } = useCurrency();

  const getCurrentLocalDatetime = () => {
    const localDate = new Date();
    const offset = localDate.getTimezoneOffset() * 60000;
    const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
    return localISOTime;
  };

  const [POData, setPOData] = useState([]);
  const [selectedPOData, setSelectedPOData] = useState([]);
  const [usersDetails, setUser] = useState([]);
  const [WareHouse, setWareHouse] = useState([]);
  const [PurchaseOrder, setPurchaseOrder] = useState([]);
  const [POlist, setPOlist] = useState([]);
  const [SelectedPO, setSelectedPO] = useState([]);
  const [SelectedSupplier, setSelectedSupplier] = useState([]);
  const [SelectedCurrency, setSelectedCurency] = useState([]);
  const [grnNo, setGrnNumber] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const itemData = location.state;
  const userId = useSelector(getUserId);
  const userName = useSelector(getUserName);
  const Company = useSelector(getCompany);
  const [PurchaseTab, setPurchaseTab] = useState(true);
  const [CostTab, setCostTab] = useState(true);
  const [loader, setLoader] = useState(false);
  const [docModal, setDocModal] = useState(false);
  const onOpenModal = () => setDocModal(true);
  const onCloseModal = () => setDocModal(false);

  // Attachment
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [attachments, setAttachments] = useState([createEmptyRow()]);
  const handleOpen = () => setAttachmentModal(true);
  const closeModal = () => setAttachmentModal(false);
  const isReadOnly = itemData?.eye === true;

  // New state for expense type and requisition
  const [expenseType, setExpenseType] = useState(null);
  const [requisitionList, setRequisitionList] = useState([]);
  const [selectedRequisition, setSelectedRequisition] = useState(null);
  const [isYusufCompany, setIsYusufCompany] = useState(false);
  const isRequisitionRequired = !!expenseType;

  const [formData, setFormData] = useState({
    GRNNO: '',
    deliveryNote: '',
    remarks: '',
    InvoiceNo: '',
    InvoiceDate: getCurrentLocalDatetime(),
    deliveryDate: getCurrentLocalDatetime(),
    TaxInvoice: '',
    costCenter1: '',
    costCenter2: '',
    costCenter3: '',
    costCenter4: '',
    Currency: '',
    exchangeRate: '',
    deliveryPoint: '',
    DeliveryType: [],
    PurchaseOrderDate: '',
    contactPerson: '',
    contatNo: '',
    taskCode: '',
    email: '',
    subcatname: '',
    location: [],
  });

  const DeliveryType = [
    { value: 'E-Ticket', label: 'E-Ticket' },
    { value: 'Hand Delivery', label: 'Hand Delivery' },
  ];

  // Define expense type options
  const expenseTypeOptions = [
    { value: 'general', label: 'General Expense' },
    { value: 'minorAsset', label: 'Minor Asset' },
    { value: 'capitalExpense', label: 'PPM Expense' },
  ];

  const formatDateToDatetimeLocal = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  useEffect(() => {
    checkCompanyName();
  }, [Company]);

  useEffect(() => {
    fetchData();
    getApprovalUser();
  }, []);

  useEffect(() => {
    if (expenseType?.value && SelectedPO?.label) {
      fetchRequisitionsByPO(SelectedPO.label);
    } else if (expenseType?.value) {
      setRequisitionList([]);
      setSelectedRequisition(null);
    }
  }, [expenseType]);

  const checkCompanyName = async () => {
    const DB = localStorage.getItem('DataBase');
    const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');

    const defaultCompany = companies.find(comp => comp.dataDB === DB);


    // ✅ Check if default company name exists in companies list
    const isCustomerCompany = companies.some(
      comp => comp.companyName === defaultCompany?.companyName
    );
    const isYusuf = defaultCompany?.companyName
      ?.toUpperCase()
      .includes("KANOO");
    setIsYusufCompany(isYusuf);
    // 🔥 Run reset if:
    // - defaultCompany not found
    // - OR company matches one of the customer companies
    if (!defaultCompany || isCustomerCompany) {
      setExpenseType(null);
      setSelectedRequisition(null);
      setRequisitionList([]);
    }
  };

  const fetchData = async () => {
    let param = `?isActive=true`;
    let WareHouse = await apiService.get('GET_WAREHOUSE_MASTER');
    setWareHouse(WareHouse?.data?.result);
    setFormData({ ...formData, exchangeRate: currencyPrecision.conversionRate });
    if (currencyPrecision) {
      setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
    }
    let PO = await apiService.get('GET_PO_LIST');

    const uniqueResult = PO?.data?.result.filter(
      (item, index, self) =>
        index === self.findIndex(
          t => t.pOrderNo === item.pOrderNo
        )
    );
    setPurchaseOrder(uniqueResult);
  };

  const getApprovalUser = async () => {
    try {
      let docParam = `?TypeOfDoc=GRN&DocId=GRN`;
      let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam);
      setGrnNumber(DocId?.data.result[0].docId);
      const params = new URLSearchParams();
      params.append('DocNo', '');
      params.append('DocumentType', 'GRN');
      const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
      setUser(response.data.result);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchRequisitionsByPO = async (poNumber) => {
    if (!isYusufCompany) {
      console.log('Requisition functionality not available for this company');
      return;
    }

    try {
      let param = `?POrderNo=${poNumber}`;
      const response = await apiService.getApiParamater('GET_REQUISITIONS_BY_PO', param);

      if (response?.data?.result && response.data.result.length > 0) {
        const validRequisitions = response.data.result.filter((req) => req.requisitionNo && req.requisitionNo.trim() !== '');

        if (validRequisitions.length > 0) {
          const requisitionOptions = validRequisitions.map((req) => ({
            value: req.requisitionNo,
            label: req.requisitionNo,
            data: req,
          }));
          setRequisitionList(requisitionOptions);
        }
      }
    } catch (error) {
      console.error('Error fetching requisitions:', error);
      toast.error('Failed to fetch requisitions');
    }
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };

  const handleMessage = (data) => {
    setMessageData(data);
    console.log(data, 'reqData');
  };

  const handleRequisitionData = (data) => {
    setItemData(data);
    console.log(data, 'reqData');
  };

  const handleAuthorization = (data) => {
    setAuthorizationData(data);
    console.log(data, 'reqData');
  };

  const handlePoChange = async (selectedOption) => {
    await fetchPOData(selectedOption || []);
    let param = `?Id=${selectedOption?.label}`;
    const PurchaseOrder = await apiService.getApiParamater('GET_PO', param);
    setPOlist(PurchaseOrder?.data?.result);
    let selectedpurchase = PurchaseOrder?.data?.result[0];

    if (selectedpurchase) {
      setSelectedPO(selectedOption);
      setSelectedSupplier({ label: selectedpurchase?.vendorName, value: selectedpurchase });
      setSelectedPOData(selectedpurchase);
      const formattedDate = selectedpurchase?.docDate ? formatDateToDatetimeLocal(selectedpurchase?.docDate) : getCurrentLocalDatetime();
      setFormData({
        ...formData,
        PurchaseOrderDate: formattedDate,
        costCenter1: { label: selectedpurchase?.costCenter1, value: selectedpurchase?.costCenter1 },
        costCenter2: { label: selectedpurchase?.costCenter2, value: selectedpurchase?.costCenter2 },
        costCenter3: { label: selectedpurchase?.costCenter3, value: selectedpurchase?.costCenter3 },
        costCenter4: { label: selectedpurchase?.costCenter4, value: selectedpurchase?.costCenter4 },
      });
      setPurchaseOrderDate(formattedDate);

      // Fetch requisitions if expense type is already set
      // if (expenseType?.value) {
      await fetchRequisitionsByPO(selectedOption?.label);
      // }
    }

    // Clear requisition selection when PO changes
    setSelectedRequisition(null);
  };

  const fetchPOData = async (selectedOption) => {
    try {
      let param = `?POrderNo=${selectedOption?.label}`;
      const PO = await apiService.getApiParamater('GET_GRN_PO', param);

      if (PO.data.statusCode === 204) {
        toast.error('No Items In this Purchase Order');
        setPOData(null);
      } else {
        setPOData(PO.data.result);
      }
    } catch (error) {
      console.error('Error fetching PO data:', error);
      toast.error('Failed to fetch PO items');
      setItemData([]);
      setPOData([]);
      setLoader(false);
    }
  };

  const handleExpenseTypeChange = (selectedOption) => {
    setExpenseType(selectedOption);
    if (selectedOption?.value !== 'requisition') {
      setSelectedRequisition(null);
      setRequisitionList([]);
    }
  };

  const handleRequisitionChange = async (selectedOption) => {
    setSelectedRequisition(selectedOption);
    if (selectedOption) {
      setLoader(true);
      try {
        let param = `?POrderNo=${SelectedPO?.label}&requisitionNo=${selectedOption.value}`;
        const response = await apiService.getApiParamater('GET_GRN_PO', param);

        if (response?.data?.result && response.data.result.length > 0) {
          const poData = response.data.result;
          if (poData && poData.length > 0) {
            setPOData(poData);
            setItemData(poData);
          } else {
            setPOData([]);
            setItemData([]);
            toast.warning('No items found for this requisition');
          }
        } else {
          setPOData([]);
          setItemData([]);
          toast.warning('No items found for this requisition');
        }
        setLoader(false);
      } catch (error) {
        console.error('Error fetching requisition items:', error);
        toast.error('Failed to fetch requisition items');
        setItemData([]);
        setPOData([]);
        setLoader(false);
      }
    } else {
      setItemData(POData || []);
    }
  };

  const handleDepartmentChange = (selectedOption) => {
    setFormData({ ...formData, Department: selectedOption?.description });
  };

  const handleLocationChange = (selectedOption) => {
    setFormData({ ...formData, location: selectedOption });
  };

  const handleDeliveryType = (selectedOption) => {
    setFormData({ ...formData, DeliveryType: selectedOption });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'deliveryDate' || name === 'PurchaseOrderDate' || name === 'InvoiceDate') {
      const dateParts = e.target.value.split('-');
      if (dateParts[0].length > 4) {
        return;
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const GenerateNumber = async () => {
    let docParam = `?TypeOfDoc=GRN&DocId=GRN`;
    const docRes = await apiService.getApiParamater('GET_DOC_ID', docParam);
    setGrnNumber(docRes?.data.result[0].docId);
    onCloseModal();
  };

  const CreateGRN = async () => {
    setLoader(true);

    // if (isRequisitionRequired && !selectedRequisition) {
    //   toast.warning('Please select a requisition number');
    //   setLoader(false);
    //   return;
    // }

    if (ItemData.length === 0) {
      toast.warning('Please add items');
      setLoader(false);
      return;
    }
    if (!formData?.location.label) {
      toast.warning('Select Location');
      setLoader(false);
      return;
    }
    if (!formData?.deliveryDate) {
      toast.warning('Select Delivery Date');
      setLoader(false);
      return;
    }
    if (!PurchaseOrderDate) {
      toast.warning('Select Purchase Order Date');
      setLoader(false);
      return;
    }
    if (!formData?.InvoiceDate) {
      toast.warning('Select Invoice Date');
      setLoader(false);
      return;
    }

    const hasBaseQty = ItemData.some((item) => item.baseQty > 0);
    if (!hasBaseQty) {
      toast.warning('At least one item must have a base quantity greater than zero.');
      setLoader(false);
      return;
    }

    const missingGL = ItemData.find((item) => !item.inventoryAccountCode);
    if (missingGL) {
      toast.warning(`Please Add GL Accounts for ${missingGL?.itemDescription}`);
      setLoader(false);
      return;
    }

    const missingGRNAcc = ItemData.find((item) => !item.GRNAccountCode);
    if (missingGRNAcc) {
      toast.warning(`Please Add GL Accounts for ${missingGRNAcc?.itemDescription}`);
      setLoader(false);
      return;
    }

    try {
      const totalAmount = ItemData.reduce((sum, row) => sum + (row.amount || 0), 0);
      const vatAmount = ItemData.reduce((sum, row) => sum + (row.vatAmount || 0), 0);
      const GrossAmount = parseFloat(totalAmount || 0) - parseFloat(vatAmount || 0);

      const apiService = new ApiService();
      const GRNDetailsData = ItemData.map((item, index) => {
        const grossAmount = parseFloat(item.amount) - parseFloat(item.vatAmount || 0);
        let vatunitPrice = item.vatAmount / item.qty;
        if (item?.batchNo) {
          if (!item?.expDate) {
            toast.warning(`Please Select Exp Date of ${item.itemDescription}`)
            setLoader(false)
            return
          }
        }

        if (item?.expDate) {
          if (!item?.batchNo) {
            toast.warning(`Please Enter Batch No of ${item.itemDescription}`)
            setLoader(false)
            return
          }
        }
        return {
          requisitionNo: selectedRequisition?.value || item?.requisitionNo || '',
          srno: item?.srno,
          itemCode: item?.ItemNo,
          itemDescription: item.itemDescription,
          uom: item.uom,
          baseUOM: item?.uom,
          specification: item.specification,
          qty: parseFloat(item.qty || 0),
          baseQty: parseFloat(item.baseQty),
          convValue: parseFloat(item?.convValue),
          unitPrice: Number(item.baseAmount).toFixed(currencyPrecision?.precision || 3),
          amount: Number(item.amount).toFixed(currencyPrecision?.precision || 3),
          baseAmount: Number(item.amount).toFixed(currencyPrecision?.precision || 3),
          vatUnitPrice: Number(parseFloat(item.qty) && !isNaN(item.vatAmount) ? parseFloat(item.vatAmount) / parseFloat(item.qty) : 0).toFixed(
            currencyPrecision?.precision || 3
          ),
          vatBaseAmount: Number(item.vatAmount).toFixed(currencyPrecision?.precision || 3),
          vatAmount: Number(item.vatAmount).toFixed(currencyPrecision?.precision || 3),
          grossAmount: Number(grossAmount).toFixed(currencyPrecision?.precision || 3),
          grossBaseAmount: Number(grossAmount).toFixed(currencyPrecision?.precision || 3),
          convToInvUOM: parseFloat(item.convValue),
          importedQty: 0,
          vatPerc: item.vat,
          extraQty: item.freeQty,
          prodDate: getCurrentLocalDatetime(),
          expDate: item.expDate,
          batchNo: item.batchNo,
          isActive: true,
          grnNo: grnNo,
          returnQty: 0,
          invoicedQty: 0,
          vatCode: 1,
          vatDesc: item.vatDes,
          vatInclusive: selectedPOData.costCenter5 === 'Included' ? true : false,
          addCharges: 0,
          inventoryAccountCode: item?.inventoryAccountCode,
          inventoryAccountName: item?.inventoryAccountName,
        };
      });
      const userData = {
        grnNo: grnNo,
        pOrderNo: selectedPOData?.pOrderNo,
        delivery_Date: selectedPOData?.deliveryDate || formData.InvoiceDate,
        status: 0,
        remarks: formData?.remarks,
        modifiedOn: getCurrentLocalDatetime(),
        modifiedBy: userName,
        terms: selectedPOData.terms,
        vendorId: SelectedSupplier?.value?.vendorId,
        vendorName: SelectedSupplier?.label,
        department: 'IT',
        costCenter1: selectedPOData?.costCenter1,
        costCenter2: selectedPOData?.costCenter2,
        costCenter3: selectedPOData?.costCenter3,
        costCenter4: selectedPOData?.costCenter4,
        isActive: true,
        grnDetailsDtos: GRNDetailsData,
        warehouse: formData?.location.label,
        poType: 'GRN',
        invoiceNo: formData.InvoiceNo,
        invoiceDate: formData.InvoiceDate,
        invoiceRef: formData.deliveryNote,
        currencyCode: SelectedCurrency.label,
        exchangeRate: SelectedCurrency?.value.conversionRate,
        transporter: formData.TaxInvoice,
        baseAmount: Number(totalAmount).toFixed(currencyPrecision?.precision || 3),
        amount: Number(totalAmount).toFixed(currencyPrecision?.precision || 3),
        grossAmount: Number(GrossAmount).toFixed(currencyPrecision?.precision || 3),
        grossBaseAmount: Number(GrossAmount).toFixed(currencyPrecision?.precision || 3),
        transport_Mode: 'From PO',
        vatInclusive: selectedPOData.costCenter5 === 'Included' ? true : false,
        expenseType: expenseType?.label,
        requisitionNumber: selectedRequisition?.value || '',
      };
      
      const response = await apiService.post('CREATE_GRN', userData);
      if (response?.data?.statusCode === 201) {
        const docBody = {
          docId: 'GRN',
          typeOfDoc: 'GRN',
        };
        const docRes = await apiService.put('UPDATE_DOC_ID', docBody);
        if (attachments) {
          let name = "GRN"
          let docNo = grnNo
          handleUpload(name, docNo)
        }

        const userData2 = {
          docType: 'GRN',
          docId: grnNo,
          department: 'IT',
          company: Company?.selectedCompany?.companyNo,
          userCode: userId,
          userName: userName,
        };
        const response2 = await apiService.post('CREATE_DOC_AUTHORIZATION', userData2);

        const paramsGet = new URLSearchParams();
        paramsGet.append('docType', 'GRN');
        paramsGet.append('docId', grnNo);
        paramsGet.append('srno', 1);
        const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);

        if (response3?.data?.result.length > 0) {
          const toEmails = response3?.data?.result?.map((user) => user.userEmail);
          const emailbody = {
            toEmails: toEmails,
            subject: 'Goods Receipt Note',
            body: '',
            docNo: grnNo,
            srNo: 1,
            docType: 'GRN',
          };
          const emailres = await apiService.post('DOC_APPROVAL_EMAIL_POST', emailbody);
        }

        const token = localStorage.getItem('Token');
        const DB = localStorage.getItem('DataBase');
        if (!token) {
          alert('Auth token is missing! Unable to proceed.');
          return;
        }

        const popupWidth = 1000;
        const popupHeight = 600;
        const popupLeft = (window.screen.width - popupWidth) / 2;
        const popupTop = (window.screen.height - popupHeight) / 2;
        const popup = window.open(
          '',
          'ReportPopup',
          `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
        );

        if (popup) {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = REPORT_URL;
          form.target = 'ReportPopup';

          const inputs = [
            { name: 'authToken', value: token },
            { name: '_db', value: DB },
            { name: 'reportName', value: 'GRN' },
            { name: 'voucherNo', value: grnNo },
          ];

          inputs.forEach(({ name, value }) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
          document.body.removeChild(form);
        }

        toast.success(`${grnNo} Created successfully`);
        setLoader(false);
        navigate('/Inventory/GRN/Listing');
      } else if (response?.data?.statusCode === 208) {
        setLoader(false);
        onOpenModal();
      }
    } catch (error) {
      setLoader(false);
      console.error('Error Creating GRN:', error);
    }
  };

  const handleBackClick = () => {
    window.history.back();
  };

  const handleReset = () => {
    setFormData({
      GRNNO: '',
      deliveryNote: '',
      remarks: '',
      InvoiceNo: '',
      InvoiceDate: getCurrentLocalDatetime(),
      deliveryDate: getCurrentLocalDatetime(),
      TaxInvoice: '',
      costCenter1: '',
      costCenter2: '',
      costCenter3: '',
      costCenter4: '',
      Currency: '',
      exchangeRate: '',
      deliveryPoint: '',
      PurchaseOrderDate: '',
      contactPerson: '',
      contatNo: '',
      taskCode: '',
      email: '',
      subcatname: '',
      location: [],
    });
    setExpenseType(null);
    setSelectedRequisition(null);
    setRequisitionList([]);
  }

  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };

  // Attachment Functions
  const handleFileSelect = useCallback((file, id) => {
    setAttachments((prev) => {
      const updated = prev.map((row) =>
        row.id === id ? { ...row, file, fileName: file.name } : row
      );
      return [...updated, createEmptyRow()];
    });
  }, []);
  const handleRemarkChange = (id, value) => {
    setAttachments((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, remarks: value } : row
      )
    );
  };
  const handleDelete = (id) => {
    setAttachments((prev) => prev.filter((row) => row.id !== id));
  };
  const handleView = (file) => {
    if (!file) return;

    if (isReadOnly) {
      setPreviewImage(file);
    } else {
      setPreviewImage(URL.createObjectURL(file));
    }
    setPreviewModal(true);
  };
  const handleUpload = async (name, docNo) => {
    const formData = new FormData();

    attachments.forEach(({ file }) => {
      if (file instanceof File) {
        formData.append("Images", file, file.name);
      }
    });

    const response = await apiService.postMultiPart(
      "UPLOAD_FILE",
      formData
    );

    if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
      const uploadedFileNames = response.data.result.split(",");

      const payload = {
        docFilesDtos: attachments
          .filter((a) => a.file)
          .map((a, index) => ({
            srno: index + 1,
            docNo: docNo,
            docType: name,
            fileName: uploadedFileNames[index]?.trim(),
            remarks: a.remarks || "",
          })),
      };

      await apiService.post("CREATE_ATTACHMENT", payload);
      return
    }
  };
  return (
    <div className="p-4">
      <div className="d-flex justify-contant-between ">
        <h5 className="col mainInvHead">Goods Receipt Note</h5>
        <div className="d-flex justify-content-end gap-1">
          <div className="col center">
            {itemData?.eye === true ? (
              ' '
            ) : (
              <>
                {loader === true ? (
                  <button className="mainbtn " type="submit">
                    <ClipLoader color="#ffffff" size={25} />
                  </button>
                ) : (
                  <button className="mainbtn " onClick={CreateGRN} type="submit">
                    <FaSave className="center mt-1 mx-2" /> <div>Save</div>
                  </button>
                )}
              </>
            )}
          </div>
          {itemData?.eye === true ? (
            ' '
          ) : (
            <button className="mainbtnRed" onClick={() => handleReset()}>
              <RiRefreshLine className="center mt-1 mx-2" />
              <div>Reset</div>
            </button>
          )}
          <button onClick={handleBackClick} className="mainbtnSecondary">
            <FaAngleLeft className="center mt-1 mx-2" />
            <div>Back</div>
          </button>
        </div>
      </div>
      <div className="cost-center-section mb-2">
        <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setPurchaseTab(!PurchaseTab)}>
          <div className="h6 pt-1">GRN Details</div>
        </div>
        <div className={`slide-content ${PurchaseTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="grnNo" className="form-label  pt-1 start">
                  GRN No
                </label>
                <input className="form-Input w-70" value={grnNo} disabled />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="catcode" className="form-label  pt-1 start">
                  Delivery Date{' '}
                </label>
                <input
                  className="form-Input w-70"
                  type="datetime-local"
                  name="deliveryDate"
                  disabled={itemData?.eye === true ? true : false}
                  value={formData.deliveryDate}
                  min={getCurrentLocalDatetime()}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="Location" className="form-label pt-1 start">
                  Location
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  value={formData.location}
                  isDisabled={itemData?.eye === true}
                  onChange={handleLocationChange}
                  options={WareHouse?.map((sup) => ({ value: sup, label: sup?.description }))}
                />
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                  Purchase Order No *
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  value={SelectedPO}
                  isDisabled={itemData?.eye === true ? true : false}
                  options={PurchaseOrder?.map((po) => ({ value: po.pOrderNo, label: po?.pOrderNo }))}
                  onChange={(selectedOption) => handlePoChange(selectedOption)}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="deliveryNote" className="form-label  pt-1 start">
                  Delivery Note No
                </label>
                <input
                  type="text"
                  className="form-Input w-70"
                  disabled={itemData?.eye === true ? true : false}
                  id="deliveryNote"
                  value={formData.deliveryNote}
                  onKeyDown={preventNegativeSign}
                  onChange={handleInputChange}
                  name="deliveryNote"
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="TaxInvoice" className="form-label  pt-1 start">
                  Tax Invoice No ( KRA )
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-Input w-70"
                  disabled={itemData?.eye === true ? true : false}
                  id="TaxInvoice"
                  value={formData.TaxInvoice}
                  onKeyDown={preventNegativeSign}
                  onChange={handleInputChange}
                  name="TaxInvoice"
                />
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">
                  Purchase Order Date
                </label>
                <input
                  type="datetime-local"
                  className="form-Input w-70"
                  disabled={true}
                  id="PurchaseOrderDate"
                  min={getCurrentLocalDatetime()}
                  value={PurchaseOrderDate}
                  onChange={handleInputChange}
                  name="PurchaseOrderDate"
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="InvoiceNo" className="form-label  pt-1 start">
                  Invoice No
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-Input w-70"
                  id="InvoiceNo"
                  disabled={itemData?.eye === true ? true : false}
                  onKeyDown={preventNegativeSign}
                  value={formData.InvoiceNo}
                  onChange={handleInputChange}
                  name="InvoiceNo"
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                  Delivery Type
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={itemData?.eye === true ? true : false}
                  options={DeliveryType}
                  value={formData.DeliveryType}
                  onChange={handleDeliveryType}
                />
              </div>
            </div>
            <div className="form-group row pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">
                  Supplier
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={true}
                  value={SelectedSupplier}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="InvoiceDate" className="form-label  pt-1 start">
                  Invoice Date
                </label>
                <input
                  type="datetime-local"
                  min={getCurrentLocalDatetime()}
                  className="form-Input w-70"
                  id="InvoiceDate"
                  value={formData.InvoiceDate}
                  disabled={itemData?.eye === true ? true : false}
                  onChange={handleInputChange}
                  name="InvoiceDate"
                />
              </div>
              <div className="col d-flex justify-content-between gap-3">
                <div className="col d-flex justify-content-between">
                  <label htmlFor="Currency" className="form-label  pt-1 start">
                    Currency
                  </label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 8,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                        color: state.isFocused ? '#000 ' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000 ',
                        },
                      }),
                    }}
                    className="w-70 p-0"
                    isSearchable={false}
                    isDisabled={itemData?.eye === true ? true : false}
                    value={SelectedCurrency}
                  />
                </div>
                <div className="col d-flex justify-content-between">
                  <label htmlFor="EXRate" className="form-label  pt-1 start">
                    EX Rate
                  </label>
                  <input
                    type="number"
                    className="form-Input w-70"
                    disabled
                    onWheel={(e) => e.target.blur()}
                    id="exchangeRate"
                    value={formData.exchangeRate}
                    onChange={handleInputChange}
                    name="exchangeRate"
                  />
                </div>
              </div>
            </div>
            {isYusufCompany && (
              <div className="form-group row pb-3">
                <div className="col d-flex justify-content-between">
                  <label htmlFor="expenseType" className="form-label pt-1 start">
                    Expense Type *
                  </label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 8,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                        color: state.isFocused ? '#000' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000',
                        },
                      }),
                    }}
                    className="w-70 p-0"
                    placeholder="Select expense type..."
                    isDisabled={itemData?.eye === true || !SelectedPO}
                    value={expenseType}
                    onChange={handleExpenseTypeChange}
                    options={expenseTypeOptions}
                  />
                </div>
                <div className="col d-flex justify-content-between">
                  <label htmlFor="requisitionNumber" className="form-label pt-1 start">
                    Requisition Number {expenseType?.value === 'requisition' && '*'}
                  </label>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 8,
                      padding: 9,
                    })}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                        color: state.isFocused ? '#000' : '#000',
                        ':hover': {
                          backgroundColor: '#F5F5F5',
                          color: '#000',
                        },
                      }),
                    }}
                    className="w-70 p-0"
                    placeholder={expenseType?.value ? 'Select requisition...' : 'N/A'}
                    isDisabled={itemData?.eye === true || !expenseType || !SelectedPO}
                    value={selectedRequisition}
                    onChange={handleRequisitionChange}
                    options={requisitionList}
                    isClearable
                  />
                </div>
                <div className="col"></div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="cost-center-section mb-2">
        <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setCostTab(!CostTab)}>
          <div className="h6 pt-1">Cost Center</div>
        </div>
        <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
          <div className="border-box2 p-3">
            <div className="form-group row pb-3">
              <div className="col d-flex justify-content-between">
                <label htmlFor="PropertyGroup" className="form-label  pt-1 start">
                  Property
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={true}
                  value={formData.costCenter1}
                  onChange={handleDepartmentChange}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="Property" className="form-label  pt-1 start">
                  Unit
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={true}
                  value={formData.costCenter2}
                  onChange={handleDepartmentChange}
                />
              </div>
              <div className="col d-flex justify-content-between">
                <label htmlFor="Department" className="form-label  pt-1 start">
                  Cost Center 3
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 8,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={true}
                  value={formData.costCenter3}
                  onChange={handleDepartmentChange}
                />
              </div>
            </div>
            <div className="form-group row ">
              <div className="col-4 d-flex justify-content-between">
                <label htmlFor="Outlet" className="form-label  pt-1 start">
                  Cost Center 4
                </label>
                <Select
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                      color: state.isFocused ? '#000 ' : '#000',
                      ':hover': {
                        backgroundColor: '#F5F5F5',
                        color: '#000 ',
                      },
                    }),
                  }}
                  className="w-70 p-0"
                  isDisabled={true}
                  value={formData.costCenter4}
                  onChange={handleDepartmentChange}
                />
              </div>
              <div className="col-4 d-flex justify-content-between">
                <label htmlFor="remarks" className="form-label  pt-1 start">
                  Remarks
                </label>
                <input
                  name="remarks"
                  type="text"
                  className="form-Input w-70"
                  disabled={itemData?.eye === true ? true : false}
                  id="remarks"
                  value={formData.remarks}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-1 px-5 mx-3"></div>
              <div className="col-2 brderbox center" onClick={() => handleOpen()}>
                {'Attachment'}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`cost-center-section`}>
        <div className="mt-3 cursor-pointer slide-header">
          <div className="nav nav-pills overslid d-flex gap-4">
            <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
              Items
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
              Authorization
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
              Message
            </div>
            <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'active' : ''}`} onClick={() => handleTabClick(3)}>
              Additional Charges
            </div>
          </div>
        </div>
      </div>
      <div className={`slide-content open`}>
        <div className={`grid-1 border-box2 p-3`}>
          {gridVisibility[0] && (
            <ItemGridGRN
              onRequisitionData={handleRequisitionData}
              itemData={POData}
              grnData={itemData}
              selectedPOData={selectedPOData}
              currencyPrecision={currencyPrecision?.precision || 3}
            />
          )}
          {gridVisibility[1] && <AuthorizationGrn handleAuthorization={handleAuthorization} usersDetails={usersDetails} setUser={setUser} itemData={POData} />}
          {gridVisibility[2] && (
            <div className="grid-3 border">
              <MessageGrid handleMessage={handleMessage} />
            </div>
          )}
          {gridVisibility[3] && <ItemGridGRN onRequisitionData={handleRequisitionData} />}
        </div>
      </div>

      <div>
        <Attachment
          open={attachmentModal}
          onClose={closeModal}
          documentNo={grnNo}
          rows={attachments}
          readOnly={isReadOnly}
          onFileSelect={handleFileSelect}
          onRemarkChange={handleRemarkChange}
          onDelete={handleDelete}
          onView={handleView}
          onSave={handleUpload}
          previewImage={previewImage}
          previewOpen={previewModal}
          closePreview={() => setPreviewModal(false)}
        />
      </div>
      <Modal size="md" show={docModal} onHide={() => setDocModal(false)} backdrop="static" contentLabel="Doc Id Modal">
        <Modal.Header closeButton>
          <Modal.Title className="center">GRN Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger">The GRN number already exists. Click "Generate" to assign a new number.</p>
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="mainbtnGry" onClick={onCloseModal}>
            Cancel
          </button>
          <button className="mainbtnRed" onClick={GenerateNumber}>
            Generate
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateGrn;